module.exports = __webpack_public_path__ + "img/link-icon.f9acbeb0.svg";